export const APPLICATIONS = {
    vrs: {
        pathList: ["/account/redeem", "/account/redeem/main"],
        bundle: "/assets/vrs/customer-portal/loader.js",
        rootElementIds: ["vrs-portal", "vrs-scripts"],
        loginRequired: false,
        theme: "light",
    },
    gfn: {
        pathList: ["/account/gfn"],
        bundle: "/assets/gfn/account/loader.js",
        rootElementIds: ["app-container", "app-scripts"],
        loginRequired: true,
        theme: "dark",
    },
    faq: {
        pathList: ["/account/faq"],
        bundle: "/assets/account/faq/faq.js",
        rootElementIds: ["account-faq-root"],
        loginRequired: false,
        theme: "light",
    },
    waitlist: {
        pathList: ["/account/rtx-50-series-verified-priority-access"],
        bundle: "/assets/account/ada-waitlist/bundle.js",
        rootElementIds: ["ada-waitlist"],
        loginRequired: true,
        theme: "light",
    },
    privacy: {
        pathList: ["/account/privacy"],
        bundle: "/assets/account/privacy/bundle.js",
        rootElementIds: ["account-privacy-root"],
        loginRequired: true,
        theme: "light",
    },
    profileInterest: {
        pathList: ["/account/profile"],
        bundle: "/assets/account/profile/bundle.js",
        rootElementIds: ["account-profile-root"],
        loginRequired: true,
        theme: "light",
    },
    communications: {
        pathList: ["/account/communications"],
        bundle: "/assets/account/communications/bundle.js",
        rootElementIds: ["account-communications-root"],
        loginRequired: true,
        theme: "light",
    },
    profile: {
        pathList: ["/account/edit-profile", "/account"],
        bundle: "/assets/account/home/bundle.js",
        rootElementIds: ["account-home-root"],
        loginRequired: true,
        theme: "light",
    },
};

export const NVIDIA_NAVBAR_FOOTER_SERVICE_PATH = "services/com.nvidia.services/nvgdcNavFooterSrvc";
export const ADOBE_DTM_SCRIPT =
    "//assets.adobedtm.com/5d4962a43b79/96fada676f0e/launch-95431b44ee81.min.js";

export const ADOBE_DTM_SCRIPT_CN =
    "https://images.nvidia.cn/aem-dam/zh_cn/adobe-launch/5d4962a43b79/e5580b866f79/launch-6292db5ae64c.min.js";
